module.exports = __webpack_public_path__ + "static/media/bg5.84378183.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg5.jpg
// module id = 165
// module chunks = 0